import { render, staticRenderFns } from "./NavigationBarNext.vue?vue&type=template&id=23cf10fd"
import script from "./NavigationBarNext.vue?vue&type=script&lang=js"
export * from "./NavigationBarNext.vue?vue&type=script&lang=js"
import style0 from "./NavigationBarNext.vue?vue&type=style&index=0&id=23cf10fd&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports